import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-template-popup',
  templateUrl: './template-popup.component.html',
  styleUrls: ['./template-popup.component.scss']
})
export class TemplatePopupComponent implements OnInit {

  public lists:any = [];
  public template:any = null;
  @Output() closeEvent:EventEmitter<any> = new EventEmitter();
  constructor(private http: HttpService, private _sanitizer: DomSanitizer) {
    this.getList();
  }

  ngOnInit(): void {
  }


  async getList() {
    let rtn:any = await this.http.post("/admin/chat-template/get-list", {status: 1})
    this.lists = rtn.templates;
  }

  select(list:any) {
    this.template = list;
  }

  close() {
    this.closeEvent.emit(null);
  }

  sendTemplate() {
    if(!this.template) {
      this.http.notify("Please select a template.");
      return;
    }

    this.closeEvent.emit(this.template.template);
  }

  html(val: string){
    return this._sanitizer.bypassSecurityTrustHtml(val);
  }
}
